import React from 'react';
import { FollowButton as Button, FollowModal as Modal } from 'src/shared/design-system/FollowShef';
import { useCurrentUser } from 'src/shared/hooks/useCurrentUserHook';
import { FollowHeaderTooltip } from './FollowHeaderTooltip';
import { useFollowButton } from './hooks';
import { FollowButtonProps } from './types';

/**
 * Follow Shef button with Modal attached for first time viewed.
 * Used on Marketplace, the Following page, etc.
 *
 * Not used on meal-plan specific pages - use FavoriteButton.tsx instead for those.
 */
export const FollowButton: React.FC<FollowButtonProps> = (props) => {
  const [currentUser] = useCurrentUser();
  const { buttonProps, isHidden, isModalShown, modalProps, tooltipProps } = useFollowButton(props);
  const { color, followingColor, iconOnly, isAnimated, isFollowing, name, onClick, showUnfollowTooltip } = buttonProps;
  const { imageUrl, isShowing, onClose, publicName } = modalProps;

  const shouldHideButton = !currentUser || isHidden;

  return shouldHideButton ? null : (
    <>
      <Button
        color={color}
        followingColor={followingColor}
        iconOnly={iconOnly}
        isAnimated={isAnimated}
        isFollowing={isFollowing}
        name={name}
        onClick={onClick}
        showUnfollowTooltip={showUnfollowTooltip}
      />
      <FollowHeaderTooltip {...tooltipProps} />
      {isModalShown && <Modal imageUrl={imageUrl} isShowing={isShowing} onClose={onClose} publicName={publicName} />}
    </>
  );
};
